import {MithrilComponent} from '@bitstillery/mithril'
import {FieldTextArea} from '@bitstillery/common/components'
import {Button, ButtonGroup} from '@bitstillery/common/components'
import {is_signal} from '@bitstillery/common/lib/store'
import {property_of} from '@bitstillery/common/lib/utils'
import m from '@bitstillery/mithril'

import type {FieldTextAreaAttrs, ModelRef} from '@bitstillery/common/types/field'

interface InlineEditableTextAttrs extends Omit<FieldTextAreaAttrs, 'model' | 'oninput'> {
    model: ModelRef
    oninput?: (value: string) => unknown
    value?: string
    onsave?: () => unknown
    oncancel?: (original_text: string) => unknown
}

function model_value(model: ModelRef): string {
    const value = is_signal(model) ? model.value : property_of(model[0], model[1])
    return typeof value === 'string' ? value : ''
}

export class InlineEditableText extends MithrilComponent<InlineEditableTextAttrs> {
    is_editing = false
    popped_text = ''

    start_editing(vnode: m.Vnode<InlineEditableTextAttrs>) {
        this.is_editing = true
        this.popped_text = model_value(vnode.attrs.model)
    }

    cancel_editing(vnode: m.Vnode<InlineEditableTextAttrs>) {
        this.is_editing = false
        vnode.attrs.oncancel?.(this.popped_text)
    }

    save_editing(vnode: m.Vnode<InlineEditableTextAttrs>) {
        this.is_editing = false
        vnode.attrs.onsave?.()
    }

    view(vnode: m.Vnode<InlineEditableTextAttrs>): m.Children {
        const children: m.Children = [
            !this.is_editing && (
                <div className='read-only-text' onclick={() => this.start_editing(vnode)}>
                    <Button className='btn-edit' icon='edit' size='xs' type='info' variant='toggle' />
                    {model_value(vnode.attrs.model)}
                </div>
            ),
            this.is_editing && (
                <div className='edit-text'>
                    <FieldTextArea model={vnode.attrs.model} oninput={vnode.attrs.oninput} />
                    <ButtonGroup>
                        <Button icon='cancel' text='Cancel' onclick={() => this.cancel_editing(vnode)} type='default' />
                        <Button icon='save' text='Save' onclick={() => this.save_editing(vnode)} type='success' />
                    </ButtonGroup>
                </div>
            ),
        ]

        return <div className='c-inline-edit'>{children}</div>
    }
}
